annualPlanSku